import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

function api() {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
}

export function listDiscountCards(schoolId) {
    return api().get('/discount-cards', { params: { schoolId } });
}

export function getDiscountCardByNumber(number, schoolId) {
    return api().get(`/discount-cards/by-number/${encodeURIComponent(number)}`, { params: { schoolId } });
}

export function createDiscountCard(schoolId, body) {
    return api().post('/discount-cards', body, { params: { schoolId } });
}

export function updateDiscountCard(id, schoolId, body) {
    return api().put(`/discount-cards/${id}`, body, { params: { schoolId } });
}

export function getLoyaltySettings(schoolId) {
    return api().get(`/schools/${schoolId}/loyalty-settings`);
}

export function updateLoyaltySettings(schoolId, body) {
    return api().put(`/schools/${schoolId}/loyalty-settings`, body);
}
